import React from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import Slider, { SeeAllSlide } from '@wix/da-shared-react/pkg/Slider';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import DuperbrowseContext from '../../../contexts/DuperbrowseContext';

import s from './StripExhibitionist.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  deviations: PapiDeviation[];
  seeAllUrl?: string;
  hasMore?: boolean;
  profileOwnerUser: PapiUser;
  sourceType?: string;
  isCurrentUserProfileOwner: boolean;
}

class StripExhibitionist extends React.Component<Props> {
  render() {
    return (
      <Slider className={s['slider']} scrollBy={0.5}>
        {this.renderSlides()}
      </Slider>
    );
  }

  renderSlides() {
    const {
      seeAllUrl,
      hasMore,
      deviations,
      profileOwnerUser,
      streamId,
      sourceType,
      isCurrentUserProfileOwner,
    } = this.props;
    const isCollection = sourceType && sourceType === 'collection';
    return (
      <DuperbrowseContext
        streamId={streamId}
        deviations={deviations}
        parent={{ title: profileOwnerUser.username }}
      >
        <OverlayContext.Provider
          value={{
            showPermanentIconWhenFaved: !(
              isCollection && isCurrentUserProfileOwner
            ),
          }}
        >
          {deviations.map(deviation => (
            <StandardThumb
              key={deviation.deviationId}
              className={s['slider-item']}
              deviation={deviation}
              height={240}
              responsive={false}
            />
          ))}
        </OverlayContext.Provider>
        {hasMore && seeAllUrl && <SeeAllSlide seeAllUrl={seeAllUrl} />}
      </DuperbrowseContext>
    );
  }
}

export default StripExhibitionist;
